import type { CollectionReference, DocumentData } from 'firebase/firestore'
import {
  collection,
  doc,
  serverTimestamp,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { modelItemStream, modelListStream } from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { buildUnsupportedConverter } from '../shared/noops'
import type { FirestorePromptToolType } from './schema'
import { schema } from './schema'

import { type ToolPromptType } from './types'
import { updateDocWithError } from '../../firestore-mobx/fetch'
import { PromptToolType } from '../../models/PromptToolType'

export * from './schema'

const unsupported = buildUnsupportedConverter<FirestorePromptToolType>()

const readConverter: FirestoreDataConverter<FirestorePromptToolType> = {
  toFirestore: unsupported.toFirestore,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

const getReadCollectionRef = (
  firestore: Firestore
): CollectionReference<FirestorePromptToolType, DocumentData> => {
  return collection(firestore, 'prompt', 'tool_prompt', 'type').withConverter(
    readConverter
  )
}

export const getPromptToolTypes = (repository: FirebaseRepository) => {
  const ref = getReadCollectionRef(repository.firestore)
  return modelListStream(repository, ref, PromptToolType)
}

export const getPromptToolType = (
  repository: FirebaseRepository,
  { type }: { type: ToolPromptType }
) => {
  const col = getReadCollectionRef(repository.firestore)
  const docRef = doc(col, type)
  return modelItemStream(repository, docRef, PromptToolType)
}

export const updatePromptToolType = async (
  repository: FirebaseRepository,
  {
    title,
    description,
    toolType,
  }: Pick<FirestorePromptToolType, 'title' | 'description'> & {
    toolType: ToolPromptType
  }
) => {
  const ref = getReadCollectionRef(repository.firestore)
  const docRef = doc(ref, toolType).withConverter(null)
  return await updateDocWithError(
    docRef,
    {
      title,
      description,
      updatedAt: serverTimestamp(),
    },
    'UpdatePromptToolTypeError'
  )
}
